import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class windowScroll {
    private styleTag: HTMLStyleElement;
    isDisabled: boolean;

    constructor() {
        this.styleTag = this.buildStyleElement();
    }
    public disable(): void {
        document.body.appendChild( this.styleTag );
        this.isDisabled = true;
    }
    public enable(): void {
        if (this.isDisabled) {
            document.body.removeChild(this.styleTag);
            this.isDisabled = false;
        }
    }

    private buildStyleElement(): HTMLStyleElement {
        const style = document.createElement( 'style' );
        style.type = 'text/css';
        style.setAttribute( 'data-debug', 'Injected by WindowScrolling service.' );
        style.textContent = `
			body {
				overflow: hidden !important ;
			}
		`;
        return( style );
    }
}
